import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MediaQueryService } from './services/media-query.service';
import { WindowSize } from './window-size.enum';


@Component({
  selector: 'app-responsive-component',
  templateUrl: './responsive.component.html',
  styleUrls: ['./responsive.component.scss']
})
export class ResponsiveComponent implements OnInit, OnDestroy {

  subscription:Subscription= new Subscription();

  windowSize: WindowSize

  constructor( mediaQueryService: MediaQueryService  ) {
    this.windowSize=mediaQueryService.getWindowSize();
    this.subscription.add(
      mediaQueryService.onWindowSizeChanged.subscribe(size=>{
        this.windowSize= size;
      })
    );
  }

  ngOnInit() {

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

}
